import React from "react";
import { graphql } from "gatsby";
import { Container, Row, Col } from "react-bootstrap";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import "./partnerLogos.scss";
import ExtractRichText from "../../molecules/ExtractRichText";

const DefaultWithThanks = (props) => {
  const { field_with_thanks_title, relationships, field_with_thanks_text } =
    props?.node;
  return (
    relationships?.field_partner_logo?.length > 0 && (
      <div className="partner-logo mb-5">
        <Container className="general-container">
          <Row className="row-gap-3">
            <h2
              className={`my-5 partner-logo__title ${
                field_with_thanks_text ? "mb-3" : ""
              }`}
            >
              {field_with_thanks_title}
            </h2>

            {field_with_thanks_text && (
              <div className="mb-3">
                <ExtractRichText richText={field_with_thanks_text?.value} />
              </div>
            )}
            {relationships?.field_partner_logo?.map((logo) => {
              return (
                <>
                  <Col xs="12" md="6" xl="3">
                    <div className="partner-logo__card">
                      <GatsbyImage
                        loading="lazy"
                        image={getImage(logo)}
                        alt={field_with_thanks_title}
                      />
                    </div>
                  </Col>
                </>
              );
            })}
          </Row>
        </Container>
      </div>
    )
  );
};

const CenteredWithThanks = (props) => {
  const { field_with_thanks_title, relationships, field_with_thanks_text } =
    props?.node;

  return (
    relationships?.field_partner_logo?.length > 0 && (
      <div className="partner-logo__centered" data-aos="fade-up">
        <Container className="general-container">
          <div>
            {field_with_thanks_title && (
              <h2
                data-aos="underlined"
                className={`underlined underlined-bg-regalBlue partner-logo__centered-title ${
                  field_with_thanks_text ? "mb-3" : ""
                }`}
              >
                {field_with_thanks_title}
              </h2>
            )}

            {field_with_thanks_text && (
              <div className="mb-3">
                <ExtractRichText richText={field_with_thanks_text?.value} />
              </div>
            )}
            <div className="partner-logo__centered-cards-wrapper">
              {relationships?.field_partner_logo?.map((logo) => {
                return (
                  <div>
                    <img src={logo?.publicUrl} alt={field_with_thanks_title}/>
                  </div>
                );
              })}
            </div>
          </div>
        </Container>
      </div>
    )
  );
};

export const ParagraphPartnerLogos = ({ node }) => {
  const { field_view_mode_partners_logo } = node;

  return (
    <>
      {field_view_mode_partners_logo == "center" ? (
        <>
          <CenteredWithThanks node={node} />
        </>
      ) : (
        <DefaultWithThanks node={node} />
      )}
    </>
  );
};

export const fragment = graphql`
  fragment ParagraphPartnerLogos on paragraph__with_thanks {
    id
    field_view_mode_partners_logo
    relationships {
      field_partner_logo {
        gatsbyImage(width: 325, fit: COVER, placeholder: BLURRED, quality: 100)
        publicUrl
        width
      }
    }
    field_with_thanks_title
    field_with_thanks_text {
      value
    }
  }
`;

export default ParagraphPartnerLogos;
